<template>
    <div>
        <p>{{ getAddress }}</p>
        <p>{{ getCity }}</p>
        <p>{{ getCountry }}</p>
    </div>
</template>
<script>
export default {
    name: 'AddressBox',
    props: {
        address: null
    },
    computed: {
        getAddress(){
            if(!this.address) return ''
            switch (this.$root.whitelabel.setting('wlCountry')){
                case 'us' || 'ca':
                    return `${ this.address.house_number } ${ this.address.street }`
                default:
                    return `${ this.address.street } ${ this.address.house_number }`
            }
        },
        getCity(){
            if(!this.address) return ''
            const regionString = this.address.region ? this.$t('regions.'+this.address.region) : ''
            switch (this.$root.whitelabel.setting('wlCountry')){
                case 'us' || 'ca':
                    return `${ this.address.city } ${ regionString } ${ this.address.postal_code }`
                default:
                    return `${ this.address.postal_code } ${ this.address.city }`
            }
        },
        getCountry() {
            return this.address ? `${this.$t('countries.' + this.address.country)}` : ''
        }
    }
}
</script>
